(() => {
    if (document.body.classList.contains('page-template-default')) {
        initLightboxes();
        initImageSliders();

        const masonryGrid = document.querySelector('.jsMasonryGrid');

        if (masonryGrid !== null) {
            imagesLoaded(masonryGrid, _ => {
                initMasonry(masonryGrid);
                new InViewAnimation();
            });
        }
        else {
            new InViewAnimation();
        }
    }

    function initMasonry(grid) {
        const masonry = new Masonry(grid, { itemSelector: '.jsGridItem' });
        setTimeout(_ => masonry.layout(), 200);
    }

    function initLightboxes() {
        const triggers = document.querySelectorAll('.jsLightbox');

        Array.prototype.forEach.call(triggers, el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                new Lightbox(el).show();
            });
        });
    }

    function initImageSliders() {
        const sliders = document.querySelectorAll('.jsImageSlider .jsSlides');

        imagesLoaded(sliders, _ => {
            Array.prototype.forEach.call(sliders, el => {
                const flickity = new Flickity(el, {
                    pageDots: false,
                    prevNextButtons: false,
                    wrapAround: true,
                    adaptiveHeight: true,
                    draggable: false
                });

                const slideCountEl = el.parentElement.querySelector('.jsSlideCount');
                const slideCount = el.querySelectorAll('.jsSlide').length;

                // Set the slide counter
                slideCountEl.innerHTML = '01/' + addZero(slideCount);

                const btnPrev = el.parentElement.querySelector('.jsArrowPrev');
                const btnNext = el.parentElement.querySelector('.jsArrowNext');

                btnPrev.addEventListener('click', e => {
                    e.preventDefault();
                    flickity.previous(true);
                });
                
                btnNext.addEventListener('click', e => {
                    e.preventDefault();
                    flickity.next(true);
                });

                // Update the slide counter on slide
                flickity.on('change', index => {
                    slideCountEl.innerHTML = addZero(index + 1) + '/' + addZero(slideCount);
                });
            });
        });
    }

    function addZero(number) {
        if (number < 10) return '0' + number;
        return '' + number;
    }
})();